// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.section,
.block {
  gap: var(--spacing-base);
}

.section-description {
  font-weight: 300;
}

.section-title span {
  display: inline-block;
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/base/section.css"],"names":[],"mappings":"AAAA;;EAEE,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB","sourcesContent":[".section,\n.block {\n  gap: var(--spacing-base);\n}\n\n.section-description {\n  font-weight: 300;\n}\n\n.section-title span {\n  display: inline-block;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
